export class OrganizationLevelPermissions {
    id: string;
    tenantId: string;
    canAccessIhModule: boolean;
    canAccessMappingModule: boolean;
    canAccessRealTimeDashboard: boolean;
}